<template>
  <footer class="dm_footer">
    <div class="dm_footer_inner">
      <div class="dm_cols">
        <!-- Marca -->
        <div class="dm_col dm_brand">
          <a href="#home" class="dm_logo" @click.prevent="go('home')">
            <img src="img/logo/logo.jpeg" alt="DataMind" />
          </a>
          <p class="dm_tagline">{{ t.footer.tagline }}</p>
          <a
            class="dm_address"
            href="https://maps.google.com/?q=Edificio Holcim, Blvd Orden de Malta, Urbanizacion Madre Selva III, El Salvador"
            target="_blank"
            rel="noopener"
          >
            <i class="icon-location"></i>
            <span>{{ t.footer.addressShort }}</span>
          </a>
        </div>

        <!-- Servicios -->
        <div class="dm_col">
          <h4 class="dm_col_title">{{ t.footer.servicesTitle }}</h4>
          <ul>
            <li v-for="(s, i) in t.services.items" :key="i">
              <a href="#services" @click.prevent="go('services')">{{
                s.title
              }}</a>
            </li>
          </ul>
        </div>

        <!-- Soluciones (proyectos) -->
        <div class="dm_col">
          <h4 class="dm_col_title">{{ t.footer.solutionsTitle }}</h4>
          <ul>
            <li v-for="(p, i) in t.projects.items" :key="i">
              <a href="#projects" @click.prevent="go('projects')">{{
                p.title
              }}</a>
            </li>
          </ul>
        </div>

        <!-- Navegación -->
        <div class="dm_col">
          <h4 class="dm_col_title">{{ t.footer.companyTitle }}</h4>
          <ul>
            <li v-for="key in navKeys" :key="key">
              <a :href="`#${key}`" @click.prevent="go(key)">{{ t.nav[key] }}</a>
            </li>
            <li>
              <a
                href="https://soporte.datamindss.com"
                target="_blank"
                rel="noopener"
                >{{ t.nav.support }}</a
              >
            </li>
          </ul>
        </div>

        <!-- Contacto -->
        <div class="dm_col">
          <h4 class="dm_col_title">{{ t.footer.contactTitle }}</h4>
          <ul class="dm_contact">
            <li>
              <i class="icon-mail-1"></i>
              <a href="mailto:ventas.sv@datamindss.com"
                >ventas.sv@datamindss.com</a
              >
            </li>
            <li>
              <i class="icon-phone"></i>
              <a href="tel:+50322210128">+503 2221 0128</a>
            </li>
            <li>
              <i class="icon-whatsapp"></i>
              <a :href="whatsappLink" target="_blank" rel="noopener">{{
                t.contact.whatsappNumber
              }}</a>
            </li>
          </ul>
          <a href="#contact" class="dm_btn dm_btn_sm" @click.prevent="go('contact')"
            >{{ t.footer.talk }} →</a
          >
        </div>
      </div>

      <!-- Llamado a la acción -->
      <div class="dm_cta">
        <div>
          <p class="dm_cta_title">{{ t.footer.ctaTitle }}</p>
          <p class="dm_cta_text">{{ t.footer.ctaText }}</p>
        </div>
        <a href="#contact" class="dm_btn" @click.prevent="go('contact')">
          {{ t.footer.ctaButton }} →
        </a>
      </div>

      <!-- Barra inferior -->
      <div class="dm_bottom">
        <p class="dm_copy">
          <strong>© {{ year }} DataMind.</strong> {{ t.footer.rights }}
        </p>
        <div class="dm_bottom_right">
          <div class="dm_lang">
            <button
              type="button"
              :class="{ active: i18n.locale === 'es' }"
              @click="i18n.setLocale('es')"
            >
              ES
            </button>
            <button
              type="button"
              :class="{ active: i18n.locale === 'en' }"
              @click="i18n.setLocale('en')"
            >
              EN
            </button>
          </div>
          <a
            href="#home"
            class="dm_top"
            :aria-label="t.footer.backToTop"
            :title="t.footer.backToTop"
            @click.prevent="go('home')"
            >↑</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { i18n } from "@/i18n";
import { navFuntions } from "@/navFuntions";

const WHATSAPP_NUMBER = "50374689732";

export default {
  name: `FooterComponent`,
  data() {
    return {
      i18n,
      navKeys: ["home", "services", "projects", "contact"],
      year: new Date().getFullYear(),
    };
  },
  computed: {
    t() {
      return i18n.m;
    },
    whatsappLink() {
      const text = encodeURIComponent(this.t.contact.whatsappMessage);
      return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    },
  },
  methods: {
    go(section) {
      navFuntions.activeSection(section);
    },
  },
};
</script>

<style scoped>
.dm_footer {
  clear: both;
  position: relative;
  z-index: 1;
  width: 100%;
  margin-top: 60px;
  background: #0a1330;
  color: #a9b4cc;
  font-size: 15px;
}

.dm_footer_inner {
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 70px 0 30px 0;
}

.dm_cols {
  display: grid;
  grid-template-columns: 1.4fr 1.3fr 1.1fr 0.8fr 1.3fr;
  gap: 40px;
}

.dm_logo img {
  display: block;
  max-width: 170px;
  max-height: 80px;
  object-fit: contain;
  background: #fff;
  border-radius: 12px;
  padding: 6px 10px;
}

.dm_tagline {
  margin: 20px 0 18px 0;
  line-height: 1.7;
  color: #a9b4cc;
}

.dm_address {
  display: flex;
  gap: 10px;
  font-size: 14px;
  line-height: 1.6;
  color: #a9b4cc;
  text-decoration: none;
}

.dm_address i {
  color: var(--main-color);
  margin-top: 3px;
}

.dm_footer .dm_col_title {
  color: #fff !important;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0 0 20px 0;
}

.dm_col ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dm_col li {
  margin: 0 0 11px 0;
  line-height: 1.5;
}

.dm_col a {
  color: #a9b4cc;
  text-decoration: none;
  transition: color 0.2s ease;
}

.dm_col a:hover,
.dm_address:hover span {
  color: #fff;
}

.dm_contact li {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dm_contact i {
  color: var(--main-color);
  width: 16px;
}

.dm_btn {
  display: inline-block;
  flex: 0 0 auto;
  font-weight: 600;
  color: #fff !important;
  background: var(--main-color);
  padding: 12px 24px;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.dm_btn:hover {
  background: var(--dm-blue-dark, #1558c9);
}

.dm_btn_sm {
  margin-top: 8px;
  padding: 8px 16px;
  font-size: 14px;
}

.dm_cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 60px;
  padding: 28px 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}

.dm_cta p {
  margin: 0;
}

.dm_cta_title {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px !important;
}

.dm_bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 40px;
  padding-top: 26px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.dm_copy {
  margin: 0;
  font-size: 14px;
}

.dm_copy strong {
  color: #fff;
}

.dm_bottom_right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dm_lang {
  display: inline-flex;
  padding: 4px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.06);
}

.dm_lang button {
  border: 0;
  background: none;
  color: #a9b4cc;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 50px;
  cursor: pointer;
}

.dm_lang button.active {
  background: var(--main-color);
  color: #fff;
}

.dm_top {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  text-decoration: none;
  transition: all 0.2s ease;
}

.dm_top:hover {
  background: var(--main-color);
  border-color: var(--main-color);
}

@media (max-width: 1100px) {
  .dm_cols {
    grid-template-columns: repeat(3, 1fr);
  }
  .dm_brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 700px) {
  .dm_footer_inner {
    width: auto;
    padding: 50px 16px 90px 16px;
  }
  .dm_cols {
    grid-template-columns: 1fr 1fr;
    gap: 32px 20px;
  }
  .dm_cta,
  .dm_bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 460px) {
  .dm_cols {
    grid-template-columns: 1fr;
  }
}
</style>
